/*
 * Ingredient glossary used by ingredient-tooltips.js to auto-tag the
 * "Ingredients:" list on product pages. Mirrors the copy on
 * templates/page.ingredients.json — update both when ingredients change.
 *
 * `match` is a list of lowercase substrings checked against each
 * comma-separated ingredient mention (after stripping punctuation and
 * parentheticals). A hit anywhere counts, so "Non-GMO Grapeseed Oils"
 * still matches the "grapeseed oil" entry.
 */
window.LOOT_INGREDIENTS = [
  {
    name: 'Coconut Oil',
    match: ['coconut oil'],
    blurb: 'A wonderful moisturiser and gentle cleanser, perfect for sensitive young skin.'
  },
  {
    name: 'Colloidal Oats',
    match: ['colloidal oats'],
    blurb: 'Finely ground Canadian oats that trap moisture in the skin and soften bath water.'
  },
  {
    name: 'Corn Starch',
    match: ['corn starch'],
    blurb: 'Non-GMO corn starch that soothes inflamed skin and promotes good circulation.'
  },
  {
    name: 'Citric Acid',
    match: ['citric acid'],
    blurb: 'Found naturally in citrus fruits — creates the fizz in bath bombs and gently exfoliates.'
  },
  {
    name: 'Essential and Fragrance Oils',
    match: ['fragrance'],
    blurb: 'Plant-based, skin-safe fragrances that are non-phototoxic and paraben & phthalate free.'
  },
  {
    name: 'FD&C Colours',
    match: ['fd&c', 'fdc', 'd&c', 'cosmetic grade colo'],
    blurb: 'Food, drug & cosmetic grade colour used at well under the 3% safety threshold — safe and non-staining.'
  },
  {
    name: 'Jojoba Oil',
    match: ['jojoba oil'],
    blurb: 'Vitamin E and B-Complex vitamins help repair skin and ease eczema flare-ups.'
  },
  {
    name: 'Grapeseed Oil',
    match: ['grapeseed oil'],
    blurb: 'High in vitamin E — softens and hydrates skin, and carries many of our fragrance oils.'
  },
  {
    name: 'Kaolin Clay',
    match: ['kaolin clay'],
    blurb: 'A naturally occurring mineral clay that helps skin retain moisture and reduces inflammation.'
  },
  {
    name: 'Magnesium Sulphate',
    match: ['magnesium sulphate', 'magnesium sulfate', 'epsom salt'],
    blurb: 'Epsom salts that help soothe sore muscles and promote relaxed sleep.'
  },
  {
    name: 'Sodium Bicarbonate',
    match: ['sodium bicarbonate', 'baking soda'],
    blurb: 'Baking soda — the base ingredient in most of our products. Anti-bacterial, anti-fungal, anti-septic.'
  },
  {
    name: 'Sodium Lauryl Sulfoacetate',
    match: ['sodium lauryl sulfoacetate', 'slsa'],
    blurb: 'SLSa — a gentle, all-natural surfactant derived from coconuts and palms.'
  },

  {
    name: 'Cream of Tartar',
    match: ['cream of tartar'],
    blurb: 'Potassium bitartrate — a natural acid salt that helps extend the fizzing reaction alongside baking soda and citric acid.'
  },
  {
    name: 'Sodium Cocoyl Isethionate',
    // Also matches "Sodium Cocyl Isethionate" — a misspelling on the live
    // Fizzy Fest listing. Keep this synonym even after that copy is fixed,
    // in case the same typo shows up elsewhere.
    match: ['sodium cocoyl isethionate', 'sodium cocyl isethionate'],
    blurb: 'A mild, coconut-derived cleansing agent that creates a gentle, low-irritation foam.'
  },
  {
    name: 'Cocamidopropyl Betaine',
    // Also matches "Cocomidopropyl Betaine" — a misspelling on the live
    // Funky Fish Food listing. Same reasoning as above.
    match: ['cocamidopropyl betaine', 'cocomidopropyl betaine'],
    blurb: 'A mild, coconut-derived co-surfactant that boosts foam and helps soften other cleansing agents in the formula.'
  }
];
